import useTranslation from 'next-translate/useTranslation'
import { OrderFormat } from '@ancon/wildcat-types'

import OrderTypeIcon from '../../../../app/components/OrderTypeIcon'
import useGetOrderFormatName from '../../../../app/hooks/useGetOrderFormatName'
import useAppDispatch from '../../../../../store/hooks/useAppDispatch'
import useAppSelector from '../../../../../store/hooks/useAppSelector'
import {
  preOrderNewOrderOrderFormatSelector,
  preOrderSupportedOrderFormatsSelector,
} from '../../../store/preOrderSelectors'
import { setNewOrderDetails } from '../../../store/preOrderSlice'
import PanelOptionTiles from '../PanelOptionTiles'

const OrderFormatHintKeys: Partial<Record<OrderFormat, string>> = {
  [OrderFormat.TakeAway]: 'newOrderPanel.formatHints.takeAway',
  [OrderFormat.EatIn]: 'newOrderPanel.formatHints.eatIn',
  [OrderFormat.Delivery]: 'newOrderPanel.formatHints.delivery',
}

export default function OrderFormatStep() {
  const { t } = useTranslation('preOrder')
  const dispatch = useAppDispatch()
  const getOrderFormatName = useGetOrderFormatName()

  const supportedOrderFormats = useAppSelector(
    preOrderSupportedOrderFormatsSelector,
  )
  const orderFormat = useAppSelector(preOrderNewOrderOrderFormatSelector)

  function handleSelect(id: string) {
    const nextOrderFormat = Number(id) as OrderFormat

    if (nextOrderFormat !== orderFormat) {
      // Order times differ per format
      dispatch(
        setNewOrderDetails({ orderFormat: nextOrderFormat, orderTime: null }),
      )
    }
  }

  return (
    <PanelOptionTiles
      ariaLabel={t('newOrderPanel.steps.orderFormat')}
      selectedId={orderFormat != null ? String(orderFormat) : null}
      onSelect={handleSelect}
      tiles={supportedOrderFormats.map(format => {
        const hintKey = OrderFormatHintKeys[format]

        return {
          id: String(format),
          icon: <OrderTypeIcon orderFormat={format} filled />,
          label: getOrderFormatName(format),
          hint: hintKey ? t(hintKey) : undefined,
        }
      })}
    />
  )
}
